import { useEffect } from 'react';
import { log } from 'log';
import { prop } from 'ramda';
import { useParams } from 'react-router-dom';
import { useIsAdmin } from 'js/hooks/user';
import { useAppSelector, useSportsbookSelector } from 'js/store/hooks';
import { htcmdService } from 'js/services/htcmd.service';

import * as helpers from '../helpers';
import * as constants from '../constants';

export const useMountSportsbook = () => {
    const isAdmin = useIsAdmin();
    const sportsbookRootURL = useAppSelector(prop('sportsbookRootURL'));
    const isAppInitialized = useSportsbookSelector(prop('isAppInitialized'));
    const { pathLang } = useParams();

    useEffect(() => {
        if (isAppInitialized) {
            try {
                window.Sportsbook.mountSportsbook(constants.CONTAINER_ID, {
                    routingPrefix: pathLang ? `/${pathLang}${sportsbookRootURL}` : sportsbookRootURL
                });

                if (isAdmin) {
                    helpers.toggleCustomizationButton();
                }

                if (htcmdService.isEnabled) {
                    htcmdService.sendMessage('sportsbookReady');
                }
            } catch (error) {
                log('log', '[SPORTSBOOK | Portal] Mount sportsbook app error', error);
            }
        }
    }, [isAppInitialized, isAdmin, pathLang, sportsbookRootURL]);
};
